<template>
  <tr class="has-text-grey has-text-weight-semibold">
    <td class="has-text-centered">
      <span class="icon is-small">
        <i class="mdi mdi-16px mdi-album"></i>
      </span>
    </td>
    <td colspan="2">
      Disc {{ discNumber }}
    </td>
  </tr>
</template>

<script>
  export default  {
    name: 'AlbumTrackDiscNumber',
    props: {
      discNumber: {
        type: Number,
        required: true
      }
    }
  }
</script>

<style scoped>
  th, td {
    padding-left: 0.2rem !important;
    padding-right: 0.2rem !important;
  }
</style>
